import angular from 'angular';
import moment from 'angular-moment';
import DateUtil from "../../../../components/logic/date_util/date_util.module";
import PowerFormatter from "../../../../components/logic/power-formatter/power-formatter.logic";
import MonthlyActivePowerService from '../../../../components/api/monthly_active_power/monthly_active_power.service';

import chartConfig from './compare-graph-yearly-active.config';

export class CompareGraphYearlyActive {
  /*@ngInject*/
  constructor($filter, $scope, $q, moment, DateUtil, PowerFormatter, MonthlyActivePowerService) {
    this.$filter = $filter;
    this.DateUtil = DateUtil;
    this.moment = moment;
    this.$q = $q;
    this.PowerFormatter = PowerFormatter;
    this.MonthlyActivePowerService = MonthlyActivePowerService;

    this.chartConfig = chartConfig(this);

    $scope.$watch('$ctrl.selectedConfigs', () => this.createGraph());
  }

  $onInit() {}

  createGraph() {
    this.endDate = this.moment().startOf('month');
    this.startDate = this.endDate.clone().subtract(12, 'months');

    if (this.chart) {
      this.chart.reflow();
    }
    if (this.selectedConfigs.length === 0) {
      return;
    }
    this.resetSeries();

    this.categories = [];
    const start = this.startDate.clone().add(this.startDate.utcOffset(), 'minutes').utc();
    for (let i = 0; i < 13; i++) {
      this.categories.push(start.valueOf());
      start.add(1, 'month');
    }

    const promises = [];
    for (let config of this.selectedConfigs) {
      promises.push(this.getActivePowers(config));
    }

    this.$q.all(promises).then(results => {
      for (let result of results) {
        this.addSeries(result.powers, result.config);
      }
      this.chart.redraw();
      this.chart.reflow();
    })
  }

  getActivePowers(config) {
    return new Promise(resolve => {
      this.MonthlyActivePowerService.show({id: config.id}, res => {
        const activePowerObjects = this.PowerFormatter.formatMonthlyActivePowers(res.powers, this.categories);
        const powers = activePowerObjects.map(power => {return power.y});
        resolve({powers, config})
      });
    });
  }

  addSeries(powers, config) {
    if (!powers) {
      return;
    }
    const graphData = this.categories.map((e, i) => {
      return [e, powers[i]];
    });
    this.chart.addSeries({
      name: config.pms_service_code,
      type: this.graphType,
      data: graphData
    });
  }

  resetSeries() {
    if (!this.chart) {
      return;
    }
    while (this.chart.series.length > 0) {
      this.chart.series[0].remove(false);
    }
  }
}

export default angular.module('leptonApp.compareGraphYearlyActive', [moment, DateUtil, PowerFormatter, MonthlyActivePowerService])
  .component('compareGraphYearlyActive', {
    template: require('./compare-graph-yearly-active.html'),
    controller: CompareGraphYearlyActive,
    bindings: {
      selectedConfigs: '=',
      configIds: '=',
      graphType: '='
    }
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/compare-graph/active/yearly/compare-graph-yearly-active.component.js